import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import {
  Row,
  Col,
  Form,
  // Checkbox
} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useGetCountriesNew } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import choosed from 'assets/images/choosed.svg';
import { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { corrAddressListItem } from '../ChangeContactInformation';
import { ContactFormData } from '../utile/ContactFormData';
export const ConfrimCard = (props: {
  corrAddressList: corrAddressListItem[];
  isShowCorrAddress1: boolean;
  isShowCorrAddress2: boolean;
}) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const { token } = useKeycloakReady();
  const [residentialAddressCountry, setresidentialAddress5] = useState('');
  const [corrAddressCountry, setCorrAddressCountry] = useState('');
  const [formData, setFormData] = useState({} as ContactFormData);
  // const [ContactInformation, setContactInformation] = useState('');
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token || '',
    '',
    '',
  );
  const myCountryList = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
    };
  });
  const corrList =
    form.getFieldValue('selectCorrList')?.length > 0
      ? props.corrAddressList.filter((item) => {
          return form.getFieldValue('selectCorrList').some((i: string) => i === item.policyNumber);
        })
      : [];
  const resList =
    form.getFieldValue('selectedPolicy')?.length > 0
      ? props.corrAddressList.filter((item) => {
          return form.getFieldValue('selectedPolicy').some((i: string) => i === item.policyNumber);
        })
      : [];
  useEffect(() => {
    setFormData(form.getFieldsValue(true));
  }, [form]);
  useEffect(() => {
    shouldFecthGetCountry(true);
  }, [shouldFecthGetCountry]);
  useEffect(() => {
    const a = myCountryList?.find((item) => item.value === form.getFieldValue('residentialAddress5'))?.label;
    const b = myCountryList?.find((item) => item.value === form.getFieldValue('corrAddress5'))?.label;
    if (a) {
      setresidentialAddress5(a);
    }
    if (b) {
      setCorrAddressCountry(b);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [setresidentialAddress5, myCountryList, form]);

  return (
    <Row justify="center" gutter={[16, 0]}>
      {formData.email != formData.emailOrigin && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.contact.Email')}
              </span>
            }
            name="email"
          >
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            >
              {form.getFieldValue('email')}
            </div>
          </BoldLabelFormItem>
        </Col>
      )}
      {(formData.mobileNumber != formData.mobileNumberOrigin ||
        (formData.mobileNumber != '' &&
          formData.mobilePhoneCountryCode !=
            formData.mobilePhoneCountryCodeOrigin +
              (formData.mobileAreaCode ? ` ${formData.mobileAreaCode}` : ''))) && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.contact.MobileNumber')}
              </span>
            }
            name="mobileNumber"
          >
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            >
              <span style={{ marginRight: '10px' }}>
                {form.getFieldValue('mobilePhoneCountryCode') ? form.getFieldValue('mobilePhoneCountryCode') : '+852'}
              </span>
              {form.getFieldValue('mobileNumber')}
            </div>
          </BoldLabelFormItem>
        </Col>
      )}
      {(formData.homeNumber != formData.homeNumberOrigin ||
        (formData.homeNumber != '' &&
          formData.homePhoneCountryCode !=
            formData.homePhoneCountryCodeOrigin + (formData.homeAreaCode ? ` ${formData.homeAreaCode}` : ''))) && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.contact.HomeNumber')}
              </span>
            }
            name="homeNumber"
          >
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            >
              <span style={{ marginRight: '10px' }}>
                {form.getFieldValue('homePhoneCountryCode') ? form.getFieldValue('homePhoneCountryCode') : '+852'}
              </span>
              {form.getFieldValue('homeNumber')}
            </div>
          </BoldLabelFormItem>
        </Col>
      )}
      {(formData.officeNumber != formData.officeNumberOrigin ||
        (formData.officeNumber != '' &&
          formData.officePhoneCountryCode !=
            formData.officePhoneCountryCodeOrigin +
              (formData.officeAreaCode ? ` ${formData.officeAreaCode}` : ''))) && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.contact.OfficeNumber')}
              </span>
            }
            name="officeNumber"
          >
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            >
              <span style={{ marginRight: '10px' }}>
                {form.getFieldValue('officePhoneCountryCode') ? form.getFieldValue('officePhoneCountryCode') : '+852'}
              </span>
              {form.getFieldValue('officeNumber')}
            </div>
          </BoldLabelFormItem>
        </Col>
      )}
      {(formData.residentialAddress1 != formData.residentialAddress1Origin ||
        formData.residentialAddress2 != formData.residentialAddress2Origin ||
        formData.residentialAddress3 != formData.residentialAddress3Origin ||
        formData.residentialAddress4 != formData.residentialAddress4Origin ||
        formData.residentialAddress5 != formData.residentialAddress5Origin) && (
        <Col xs={24} md={24}>
          <Form.Item
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.contact.ResidentialAddress')}
              </span>
            }
            name="residentialAddress1"
          >
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress1')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress2')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress3')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress4')}
            </div>
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                paddingBottom: '4px',
              }}
            >
              {residentialAddressCountry}
            </div>
          </Form.Item>
        </Col>
      )}
      {form.getFieldValue('selectedPolicy')?.length > 0 && props.isShowCorrAddress1 && (
        <Col xs={24} md={24}>
          {/* <div className="header2">
            <div
              style={{
                fontSize: '33px',
                fontFamily: 'Roboto400',
                color: '#6f7072',
              }}
            >
              {t('life.MakeRequest.contact.PolicyInformation')}
            </div>
          </div> */}
          <Form.Item
            label={
              <span
                style={{
                  color: '#6f7072',
                  fontWeight: 'normal',
                  fontSize: '17px',
                  fontFamily: 'Roboto500',
                  // marginTop: '10px',
                }}
              >
                {t('life.MakeRequest.contact.CorrespondenceAddress')}
              </span>
            }
            name="corrAddress1"
          >
            <div style={{ display: 'grid' }}>
              {resList?.map((item, index) => (
                <div className="checkBox" key={index}>
                  <div style={{ marginTop: '5px', marginRight: '16px' }}>
                    <img src={choosed} alt="" />
                  </div>
                  <div>
                    <div
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        marginTop: '5px',
                      }}
                    >
                      {i18n.language == 'en' ? item.productName : item.productNameTc}
                    </div>
                    <div
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        marginTop: '10px',
                      }}
                    >
                      {item.policyNumber}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress1')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress2')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress3')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('residentialAddress4')}
            </div>
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                paddingBottom: '4px',
              }}
            >
              {residentialAddressCountry}
            </div>
          </Form.Item>
        </Col>
      )}
      {form.getFieldValue('selectCorrList')?.length > 0 && props.isShowCorrAddress2 && (
        <Col xs={24} md={24}>
          {/* <div className="header2">
            <div
              style={{
                fontSize: '33px',
                fontFamily: 'Roboto400',
                color: '#6f7072',
              }}
            >
              {t('life.MakeRequest.contact.PolicyInformation')}
            </div>
          </div> */}
          <Form.Item
            label={
              <span
                style={{
                  color: '#6f7072',
                  fontWeight: 'normal',
                  fontSize: '17px',
                  fontFamily: 'Roboto500',
                  // marginTop: '10px',
                }}
              >
                {t('life.MakeRequest.contact.CorrespondenceAddress')}
              </span>
            }
            name="corrAddress1"
          >
            <div style={{ display: 'grid' }}>
              {corrList?.map((item, index) => (
                <div className="checkBox" key={index}>
                  <div style={{ marginTop: '5px', marginRight: '16px' }}>
                    <img src={choosed} alt="" />
                  </div>
                  <div>
                    <div
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        marginTop: '5px',
                      }}
                    >
                      {i18n.language == 'en' ? item.productName : item.productNameTc}
                    </div>
                    <div
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        marginTop: '10px',
                      }}
                    >
                      {item.policyNumber}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('corrAddress1')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('corrAddress2')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('corrAddress3')}
            </div>
            <div
              style={{
                border: 'none',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
              }}
            >
              {form.getFieldValue('corrAddress4')}
            </div>
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                paddingBottom: '4px',
              }}
            >
              {corrAddressCountry}
            </div>
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};
